

export const webSectionData =[
    {title : "Loan Details", data : [],key : "loan-details"},
    {title : "Additional Info", data: [],key :"additional-info"},
    {title : "Communication Details", data: [],key :"communication"}
]